export class ListAdminWorkspacesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workspaces",
            "baseName": "workspaces",
            "type": "Array<AdminWorkspace>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ListAdminWorkspacesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
